<template>
  <header class="header">

    <div class="container">
      <div class="header__row">
        <div class="header__logo">
          <router-link :to="{ path: '/' }">
            <img src="@/assets/images/logo.svg" alt="Logo DocDocPro" />
          </router-link>
        </div>

        <div class="main-menu">
          <ul class="main-menu--items">
            <li key="profile" v-if="isAuthenticated">
              <router-link :to="{ name: 'profile' }">Mon Compte</router-link>
            </li>
            <li key="login" v-if="!isAuthenticated">
              <router-link :to="{ name: 'login' }">Connexion</router-link>
            </li>
            <li key="contact">
              <router-link :to="{ name: 'contactPage' }">Contact</router-link>
            </li>
            <li key="logout" v-if="isAuthenticated && !isMobile">
              <a class="logout" @click="setLogoutUser">Déconnexion</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: "HeaderMain",
  computed: {
    ...mapGetters([
      'isAuthenticated'
    ]),
    isMobile() {
      return this.$vssWidth < 992
    },
  },
  methods: {
    ...mapActions([
      'setLogoutUser'
    ]),
  },
  mounted() { }
}
</script>
<style lang="scss">
  @import "@/scss/helpers/mixins";
  @import "@/scss/helpers/variables";

.header {
  display: block;
  width: 100%;

  &__row {
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    @include min($lg) {
      height: 100px;
    }
  }

  &__logo {
    img {
      width: 102px;

      @include min($lg) {
        width: 191px;
      }
    }
  }
}

.main-menu {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  font-size: 18px;
  font-weight: 700;

  @include min($lg) {

  }

  &--items {
    display: flex;
    gap: 15px;
    list-style: none;
    padding: 0;

    @include min($lg) {
      gap: 60px;
    }
    a {
      font-family: $campaign;
      font-size: 14px;
      font-weight: $bold;
      text-decoration: none;
      cursor: pointer;

      @include min($lg) {
        font-size: 20px;
      }
    }
  }
}
</style>